
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { ISchedule, IScheduleEntry } from '@app-types/websocket/schedule.types';
import { IHandoverSetting, createArrayCopyAndSort, createScheduleSide, mergeAndClean } from '../ScheduleCalc';

const applyChanges = (schedule:ISchedule, clearDaysBefore?:Date, clearDaysAfter?:Date):ISchedule => {

  const newSchedule:ISchedule = {
    id:schedule.id,
    lastHandover:schedule.lastHandover,
    status:schedule.status,
    name:schedule.name,
    school:schedule.school,
    data:{
      children:schedule.data.children,
      parentA:schedule.data.parentA,
      parentB:schedule.data.parentB,
      scheduleEntriesParentA:schedule.data.scheduleEntriesParentA,
      scheduleEntriesParentB:schedule.data.scheduleEntriesParentB,
    }
  }

  const sideA = clearDays(createArrayCopyAndSort(schedule.data.scheduleEntriesParentA), clearDaysBefore, clearDaysAfter);
  const sideB = clearDays(createArrayCopyAndSort(schedule.data.scheduleEntriesParentB), clearDaysBefore, clearDaysAfter);

  newSchedule.data.scheduleEntriesParentA = createScheduleSide(sideA);
  newSchedule.data.scheduleEntriesParentB = createScheduleSide(sideB);

  return newSchedule;
}

const clearDays = (side:IScheduleEntry[], clearDaysBefore?:Date, clearDaysAfter?:Date):IScheduleEntry[] => {

    const newSide:IScheduleEntry[] = [];

    if (clearDaysBefore) {
      const clear = new Date(clearDaysBefore);
      clear.setHours(9,0,0,0);
      const time = clear.getTime();
      for(const entry of side) {
        if (entry.endTime < time) {
          continue;
        } else if (entry.startTime < time && entry.endTime >= time) {
          newSide.push({
            ...entry,
            startTime:time
          });
        } else {
          newSide.push(entry);
        }

      }
    }

    if (clearDaysAfter) {
      const clear = new Date(clearDaysAfter);
      clear.setHours(20,0,0,0);
      const time = clear.getTime();
      for(const entry of side) {
        if (entry.startTime > time) {
          continue;
        } else if (entry.startTime < time && entry.endTime >= time) {
          newSide.push({
            ...entry,
            endTime:time
          });
        } else {
          newSide.push(entry);
        }
      }
    }

    newSide.sort((a,b) => a.startTime - b.startTime);

    return newSide;
}


export { applyChanges };


// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Cleardays/CleardaysCalc.ts